

export class PbiWorkSpaceModel {
  environment: string;
  location: string;
  pbiworkspace: boolean;
  pbiworkspacedestroy: boolean;
  pbiworkspaceName: string;
  workspaceName: string;
  userEmails: string;
  Access: string;
  addremove: string;
  requestedby: string;
}


//export class PbiWorkSpaceUserModel {
//  environment: string;
//  workspaceName: string;
//  userEmail: string;
//  Access: string;
//  addremove: string;
//}
